import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"currentColor\" fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M2.933 7.445c5.65-4.535 13.833-4.218 19.122.794a.75.75 0 1 1-1.032 1.089C16.28 4.833 8.94 4.548 3.872 8.615q-.422.338-.817.713a.75.75 0 0 1-1.032-1.089q.44-.417.91-.794\"></path><path fill-rule=\"nonzero\" d=\"M4.859 11.5c3.965-3.966 10.395-3.966 14.36 0a.75.75 0 0 1-1.06 1.06 8.655 8.655 0 0 0-12.24 0 .75.75 0 0 1-1.06-1.06\"></path><path fill-rule=\"nonzero\" d=\"M7.709 14.594a6.124 6.124 0 0 1 8.66 0 .75.75 0 0 1-1.06 1.06 4.624 4.624 0 0 0-6.54 0 .75.75 0 0 1-1.06-1.06\"></path><path d=\"M12.039 18.775a1.188 1.188 0 1 0 0-2.375 1.188 1.188 0 0 0 0 2.375\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }